var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemoveMinus = function SvgRemoveMinus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666672 8C0.666672 3.94992 3.94992 0.666672 8 0.666672C12.0501 0.666672 15.3333 3.94992 15.3333 8C15.3333 12.0501 12.0501 15.3333 8 15.3333C3.94992 15.3333 0.666672 12.0501 0.666672 8ZM8 2.00001C4.6863 2.00001 2.00001 4.6863 2.00001 8C2.00001 11.3137 4.6863 14 8 14C11.3137 14 14 11.3137 14 8C14 4.6863 11.3137 2.00001 8 2.00001Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33334 8.00001C4.33334 7.63182 4.63182 7.33334 5.00001 7.33334H11C11.3682 7.33334 11.6667 7.63182 11.6667 8.00001C11.6667 8.3682 11.3682 8.66668 11 8.66668H5.00001C4.63182 8.66668 4.33334 8.3682 4.33334 8.00001Z",
    fill: "#EA4335"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveMinus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-minus.dde7e0e2.svg";
export { ForwardRef as ReactComponent };